import { Container } from "react-bootstrap";
import "./App.css";
import HomePage from "./components/HomePage";
import styles from "./App.module.css";
import { useState, useEffect, lazy, Suspense } from "react";
import { useTheme } from "./ThemeContext";
import NavBarModule from "./NavBarModule";
import FooterModule from "./FooterModule";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import NotFoundPage from "./components/NotFoundPage";

const DataCenterPage = lazy(() => import("./components/DataCenterPage"));
const DedicatedServersPage = lazy(() =>
  import("./components/DedicatedServersPage")
);
const VirtualServersPage = lazy(() =>
  import("./components/VirtualServersPage")
);
const ResourcesPage = lazy(() => import("./components/ResourcesPage"));
const PrivacyPage = lazy(() => import("./components/PrivacyPage"));
const TermsPage = lazy(() => import("./components/TermsPage"));
const ReferralPage = lazy(() => import("./components/ReferralPage"));
const VirtualHostingPage = lazy(() =>
  import("./components/VirtualHostingPage")
);

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isXs: width < 576,
    isSm: width >= 576 && width < 768,
    isMd: width >= 768 && width < 992,
    isLg: width >= 992 && width < 1200,
    isXl: width >= 1200,
  };
}

function useYandexMetrika() {
  const location = useLocation();
  useEffect(() => {
    if (window.ym) {
      window.ym(95886642, "hit", location.pathname + location.search);
    }
  }, [location]);
}

// const pageMapping = {
//   home: HomePage,
//   dataCenter: DataCenterPage,
//   virtualServers: VirtualServersPage,
//   dedicatedServers: DedicatedServersPage,
//   resources: ResourcesPage,
// };

const pageMapping = {
  home: "",
  dataCenter: "data-center",
  virtualServers: "servers",
  dedicatedServers: "dedicated",
  resources: "brandbook",
  privacy: "privacy",
  terms: "terms",
  referral: "referral",
  virtualHosting: "virtual-hosting",
};

function App() {
  const [isNavOpened, setIsNavOpened] = useState(false);
  const windowSize = useWindowWidth();
  const { s, toggleTheme } = useTheme();
  // const [curPage, setCurPage] = useState("resources");
  const navigate = useNavigate();

  const setCurPage = (page) => {
    console.log(page);
    navigate(`/${pageMapping[page]}`);
  };
  // const Page = pageMapping[curPage];

  useYandexMetrika();
  return (
    <div className="App" style={s.app}>
      <Container fluid>
        <div className={`${styles.landingContainer} pt-3`}>
          <NavBarModule
            setIsOpened={setIsNavOpened}
            isOpened={isNavOpened}
            {...windowSize}
            setCurPage={setCurPage}
          />
          <Routes>
            <Route
              path="/"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <HomePage windowSize={windowSize} setCurPage={setCurPage} />
                </Suspense>
              }
            />
            <Route
              path="/data-center"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <DataCenterPage
                    windowSize={windowSize}
                    setCurPage={setCurPage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/servers"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <VirtualServersPage
                    windowSize={windowSize}
                    setCurPage={setCurPage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/dedicated"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <DedicatedServersPage
                    windowSize={windowSize}
                    setCurPage={setCurPage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/brandbook"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <ResourcesPage
                    windowSize={windowSize}
                    setCurPage={setCurPage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/privacy"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <PrivacyPage
                    windowSize={windowSize}
                    setCurPage={setCurPage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/terms"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <TermsPage windowSize={windowSize} setCurPage={setCurPage} />
                </Suspense>
              }
            />
            <Route
              path="/referral"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <ReferralPage
                    windowSize={windowSize}
                    setCurPage={setCurPage}
                  />
                </Suspense>
              }
            />
            <Route
              path="/virtual-hosting"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <VirtualHostingPage
                    windowSize={windowSize}
                    setCurPage={setCurPage}
                  />
                </Suspense>
              }
            />
            <Route
              path="*"
              element={
                <Suspense fallback={<div>Загрузка...</div>}>
                  <NotFoundPage
                    windowSize={windowSize}
                    setCurPage={setCurPage}
                  />
                </Suspense>
              }
            />
          </Routes>
          {/* <Page windowSize={windowSize} setCurPage={setCurPage} /> */}
          {/* <HomePage windowSize={windowSize} /> */}
          <FooterModule {...windowSize} setCurPage={setCurPage} />
        </div>
      </Container>
    </div>
  );
}

export default App;
